import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { dataCleanseService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";


const useDataCleanseCompleteMutation = ({
	paidYear,
	paidMonth,
	onSuccessHandler,
}: {
	paidYear: string;
	paidMonth: string;
	onSuccessHandler?: Function;
}) => {
	const dispatch = useDispatch();

	return useMutation(
		() => {
			dispatch(uiActions.showSpinnerOverlay());

			return dataCleanseService.completeReview({
				paidYear,
				paidMonth,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Calculation process is in progress now",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useDataCleanseCompleteMutation;
